import { Glucose } from "@cur8/health-risks-calc";
import { useQueryParams } from "@pomle/react-router-paths";
import { queries } from "render/routes/paths";
import { toChartRanges } from "render/ui/presentation/RangeChart/lib/risk";
import { MetricDetails } from "render/views/Report/AppointmentDataView/components/MetricsSection/components/layouts/Details";
import { getMetricHistory } from "render/views/Report/AppointmentDataView/components/MetricsSection/components/metrics/utils/getMetricHistory";
import { useGlucoseMetric } from "render/views/Report/AppointmentDataView/components/MetricsSection/hooks/usePatientReportMetrics";
import { Trans } from "./trans";

export function MetricGlucoseDetails() {
  const { data } = useGlucoseMetric();

  const [params, setParams] = useQueryParams(queries.metric);
  const numOfScans = data?.length || 1;
  const scanNum = params.scan[0] || numOfScans;
  const setScanNum = (num: number) =>
    setParams({
      scan: [num],
    });

  if (!data) {
    return undefined;
  }

  const { cur: current, prev: previous } = getMetricHistory(data, scanNum);
  const riskRanges = Glucose.rangesFor();

  const values = {
    subLabel: "mmol/L",
    value: current?.unit["mmol/L"],
    previousValue: previous?.unit["mmol/L"],
    metricRating: current && riskRanges.findRisk(current.unit),
    scanDate: current?.measurement.timestampStart,
    ranges: toChartRanges(riskRanges.entries),
  };

  return (
    <MetricDetails
      label={<Trans.MetricName />}
      values={values}
      scanNum={scanNum}
      setScanNum={setScanNum}
      numOfScans={numOfScans}
      FAQText={Trans.FAQ}
      hideChange
    />
  );
}
